// 앱을 추가할 때는 src/data/apps/<slug>.ts를 만들고 여기에 한 줄 더한다.
import { AppData } from "../types/app";
import limelink from "./apps/limelink";
import limenote from "./apps/limenote";
import ddirong from "./apps/ddirong";
import dokbox from "./apps/dokbox";

export const APPS: AppData[] = [limelink, limenote, ddirong, dokbox];

export const getApp = (slug: string) => APPS.find((a) => a.slug === slug);
